export enum PerfilId {
  Admin = 1,
  CompanyAdmin = 2,
  PartyOwner = 3,
}

export interface UserProfile {
  id_usuario: string;
  nome: string;
  email: string;
  id_perfil: PerfilId;
  id_empresa?: string | null;
  /** 'PENDENTE' enquanto o convidado não conclui o cadastro (senha + CPF). */
  status?: string | null;
}
